// TODO: fix this cyclic dependency
// eslint-disable-next-line import/no-cycle
import {getAuthorizationHeader, logout} from 'util/Authentication';

/**
 * A class that makes calls to the API.
 */
class API {
  /**
   * The base URL for the API.
   */
  static BASE = `${process.env.REACT_APP_API_BASE}/api/v1/`;

  /**
   * Parses the result of the HTTP response.
   * @param {object} res The HTTP response.
   */
  static parseResponse = (response) => {
    const {ok, status, statusText} = response;

    if (!ok) {
      if (status === 401) {
        logout();
      }

      throw new Error(`${status}: ${statusText}`);
    }

    return response.json();
  };

  /**
   * Parses key-value pairs into HTTP request parameters.
   * @param {object} requestParams The object containing the key-value pairs.
   */
  static parseRequestParams = (requestParams) => {
    if (!requestParams || requestParams.length === 0) return '';
    let parameterUrlString = '?';

    Object.entries(requestParams).forEach(([key, value]) => {
      parameterUrlString += `${key}=${value}&`;
    });

    return parameterUrlString.slice(0, -1);
  };

  /**
   * Makes a GET request to the API.
   * @param {string} relativeUrl The URL mapping in the API.
   * @param {object} requestParams The URL request parameters.
   */
  static find = async (relativeUrl, requestParams) => {
    const url = API.BASE + relativeUrl + API.parseRequestParams(requestParams);
    const header = getAuthorizationHeader();
    const response = await fetch(url, {
      method: 'get',
      mode: 'cors',
      headers: {
        'Content-type': 'application/json',
        Authorization: header,
      },
    });

    return API.parseResponse(response);
  };

  /**
   * Makes a PUT or POST request to the API.
   * @param {string} relativeUrl The URL mapping in the API.
   * @param {object} data The data to PUT or POST.
   * @param {object} requestParams The URL request parameters.
   */
  static save = async (relativeUrl, data, requestParams) => {
    let url = API.BASE + relativeUrl;
    let type;

    if (data.id) {
      type = 'put';
      url += data.id;
    } else {
      type = 'post';
    }
    url += API.parseRequestParams(requestParams);

    const header = getAuthorizationHeader();
    const response = await fetch(url, {
      method: type,
      mode: 'cors',
      headers: {
        'Content-type': 'application/json',
        Authorization: header,
      },
      body: JSON.stringify(data),
    });

    return API.parseResponse(response);
  };

  /**
   * Makes a DELETE request to the API.
   * @param {string} relativeUrl The URL mapping in the API.
   * @param {data} data The data containing the ID to delete.
   */
  static delete = async (relativeUrl, data) => {
    const {id} = data;

    if (!id) {
      throw new Error('No ID provided.');
    }

    const url = API.BASE + relativeUrl + id;
    const header = getAuthorizationHeader();
    const response = await fetch(url, {
      method: 'delete',
      mode: 'cors',
      headers: {
        'Content-type': 'application/json',
        Authorization: header,
      },
    });

    return API.parseResponse(response);
  };
}

export default API;
